<template>
  <transition name="dialog-from-top">
    <div
      class="dialog"
      @touchmove.self.prevent
      @click.self="closeDialog"
      v-show="visible"
    >
      <div class="dialog-content">
        <div class="dialog-title" v-html="title"></div>
        <div
          class="dialog-text"
          v-for="(content, index) in contents"
          :key="index"
        >
          <p class="dialog-text-titleName">课程名称：</p>
          <p class="dialog-text-content">{{ content.name }}</p>
        </div>
        <div class="dialog-footer">
          <div class="dialog-btn" @click="closeDialog">好的</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    contents: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  methods: {
    closeDialog() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" scoped>
.dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  background: rgba(0, 0, 0, 0.5);

  &-content {
    box-sizing: border-box;
    width: 300px;
    padding: 16px;
    border-radius: 12px;
    background: #fff;
  }

  &-title {
    font-size: 16px;
    color: #212831;
    text-align: center;
    font-weight: 500;
  }

  &-text {
    margin-top: 16px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 18px;
    &-titleName {
      height: 18px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 18px;
    }
    &-content {
      padding-top: 6px;
    }
  }

  &-footer {
    margin-top: 28px;
  }

  &-btn {
    width: 128px;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    margin: 0 auto;
    background: #e02727;
    color: #fff;
    text-align: center;
    border-radius: 20px;
  }
}

.dialog-from-top-enter-active,
.dialog-from-top-leave-active {
  transition: all 0.3s;

  .dialog-content {
    transition: all 0.3s;
  }
}

.dialog-from-top-enter,
.dialog-from-top-leave-to {
  opacity: 0;

  .dialog-content {
    transform: translateY(-10%);
    opacity: 0;
  }
}
</style>
